import Seperator from '@components/std-components/Seperator'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { EnhancedTotalViewKeyMap } from '@modules/order/constants/keys'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { orderKPIGlobalTopBarStore } from '@modules/order/stores/OrderKPIGlobalTopBarStore'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import formatNumberByLocale from '@utils/format-number-by-locale'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as css from '../../OrderTopbarKPITotals.css'
import { nav } from '@stores'
import { getKPICurrency } from '@modules/order/utils/get-kpi-currency'

const EnhancedOrderTopbarKPITotals: React.FC<any> = () => {
  return useObserver(function useHook() {
    const {
      uiStore: {
        dataStore: { summary },
        quantityTypeStore: { type }
      }
    } = useOrderContext()
    const orderTopbarData = orderKPIGlobalTopBarStore.enhancedOrderKPIsForGlobalTopBar
    const currency = getKPICurrency(nav.queryParams.orderType, summary)
    const totalSkus = orderTopbarData?.totalProducts || 0
    const { t } = useTranslation()

    return (
      <div className={css.totalsWrapper}>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 16px'
        />
        <div className={css.qtyWrapper}>
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('showroom.orderTopbarKPITotals.totalSKUS', 'TOTAL SKUS')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant={'h6'}>{formatNumberByLocale(totalSkus)}</Typography>
          </div>
        </div>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 16px'
        />
        <div className={css.qtyWrapper}>
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('showroom.orderTopbarKPITotals.totalQuantity', 'TOTAL QUANTITY')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant={'h6'}>
              {formatNumberByLocale(
                orderTopbarData?.[EnhancedTotalViewKeyMap[type]?.totalQuantity]
              ) || 0}
            </Typography>
          </div>
        </div>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 16px'
        />
        <div className={css.qtyWrapper}>
          <div className={css.topBarLabel}>
            {' '}
            <Typography variant={'subtitle1Grey'}>
              {t('showroom.orderTopbarKPITotals.totalValue', 'TOTAL VALUE')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant={'h6'}>
              {formatCurrencyValueByLocale(
                currency ?? '',
                orderTopbarData?.[EnhancedTotalViewKeyMap[type]?.totalValue] || 0
              )}
            </Typography>
          </div>
        </div>
      </div>
    )
  })
}

export default EnhancedOrderTopbarKPITotals
